import MultipleSelect from "../../../Components/CluppForms/MultipleSelect";
import TitleHeaders from "../../../Components/CluppForms/TitleHeaders";

const CancelationReason = ({ state, setState, field }) => {

  const options = state.isMultipleProducts
    ? [
        {
          id: "No me gusta el seguro de Clupp",
          label: "No me gusta el seguro de Clupp",
          value: "No me gusta el seguro de Clupp",
        },
        {
          id: "Dificultad económica",
          label: "Dificultad económica",
          value: "Dificultad económica",
        },
        {
          id: "Encontré un mejor seguro",
          label: "Encontré un mejor seguro",
          value: "Encontré un mejor seguro",
        },
        { id: "Otro", label: "Otro (escribe tu razón)", value: "" },
      ]
    : [
        {
          id: `Vendí o cambié mi ${state.isADevice ? "dispositivo" : "vehículo"}`,
          label: `Vendí o cambié mi ${state.isADevice ? "dispositivo" : "vehículo"}`,
          value: `Vendí o cambié mi ${state.isADevice ? "dispositivo" : "vehículo"}`,
        },
        {
          id: "Dificultad económica",
          label: "Dificultad económica",
          value: "Dificultad económica",
        },
        {
          id: `Casi no uso mi ${state.isADevice ? "dispositivo" : "vehículo"}`,
          label: `Casi no uso mi ${state.isADevice ? "dispositivo" : "vehículo"}`,
          value: `Casi no uso mi ${state.isADevice ? "dispositivo" : "vehículo"}`,
        },
        {
          id: "No me gusta el seguro de Clupp",
          label: "No me gusta el seguro de Clupp",
          value: "No me gusta el seguro de Clupp",
        },
        {
          id: "Encontré un mejor seguro",
          label: "Encontré un mejor seguro",
          value: "Encontré un mejor seguro",
        },
        {
          id: "Solo lo necesitaba para un trámite",
          label: "Solo lo necesitaba para un trámite",
          value: "Solo lo necesitaba para un trámite",
        },
        { id: "Otro", label: "Otro (escribe tu razón)", value: "" },
      ];
  return (
    <>
      <TitleHeaders
        title={"¿Cuál es la principal razón de tu cancelación?"}
        subtitle={"Por favor, selecciona una de las siguientes opciones."}
        isRequired={true}
      />

      <MultipleSelect
        options={options}
        state={state}
        setState={setState}
        field={field}
        isMultiple={false}
        haveOtherTextField={true}
      />
    </>
  );
};

export default CancelationReason;
